export const SYMFONY_ENV = document.getElementById('root')?.dataset.env || 'prod';
